"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiLink = void 0;
var palette_1 = require("../../../theme/global/palette");
var typography_1 = require("../../global/typography");
// Hardcoded scoped color won't be part of our theme as UX would like to keep the default <a>'s look and feel
var visitedLinkColor = '#551A8B';
exports.MuiLink = {
    root: __assign(__assign({}, typography_1.typography.body1), { color: palette_1.palette.primary.main, '&:visited': {
            color: visitedLinkColor,
        }, '&:hover': {
            color: palette_1.palette.primary.light,
        }, '&:focus': {
            color: palette_1.palette.primary.dark,
            outlineOffset: 3,
        }, '&:active': {
            color: palette_1.palette.primary.dark,
            outlineOffset: 3,
        } }),
};
